module.exports = __webpack_public_path__ + "img/04.7d020e52.png";